import React from 'react';
import ReactDOM from 'react-dom';
import View from './forgotPassword/ForgotPasswordView.jsx';

export default ({
  element,
  props,
}) => {
  ReactDOM.render(
    <View {...props} />,
    element
  );
};
